window.addEventListener("load", function () {
  var swiper = new Swiper(".swiper-header", {
    autoplay: {
      delay: 6000,
    },
    pagination: {
      el: ".swiper-header-pagination",
    }, 
    preloadImages: false,
    lazy: {
      loadPrevNext: false,
      loadOnTransitionStart: false,
    },

  });

});
